export enum EstadoPrograma {
  EN_REGISTRO = 'EN_REGISTRO',
  ELEGIBLE = 'ELEGIBLE',
  NO_ELEGIBLE = 'NO_ELEGIBLE',
}
